import { Toaster } from 'react-hot-toast';

/**
 * The app's single toast surface, themed to match the rest of the UI.
 *
 * Mounted once in main.tsx. Positioned top-centre rather than the library
 * default of top-right because the right edge of a phone screen is where the
 * thumb sits, and a toast under a thumb is a toast nobody reads.
 *
 * The bottom offset clears the 4rem mobile nav plus the home indicator, the
 * same way page content does.
 */
export function AppToaster() {
    return (
        <Toaster
            position="top-center"
            containerStyle={{ top: 'calc(0.75rem + env(safe-area-inset-top))' }}
            toastOptions={{
                duration: 4000,
                style: {
                    background: 'var(--fd-surface-2)',
                    color: 'var(--fd-text-bright)',
                    border: '1px solid var(--fd-border-strong)',
                    borderRadius: 'var(--fd-r-lg)',
                    fontSize: '0.9375rem',
                    padding: '10px 14px',
                    maxWidth: 'min(92vw, 30rem)',
                    boxShadow: 'var(--fd-shadow-3)',
                },
                success: { iconTheme: { primary: 'var(--fd-success)', secondary: 'var(--fd-surface-2)' } },
                error: { duration: 6000, iconTheme: { primary: 'var(--fd-danger)', secondary: 'var(--fd-surface-2)' } },
            }}
        />
    );
}
